import React, { useState } from 'react';

const Slideshow = ({ images }) => {
  const [current, setCurrent] = useState(0);
  if (!images?.length) return null;

  // Show 3 images at a time, centered on current
  const getVisibleImages = () => {
    if (images.length <= 3) return images;
    const visible = [];
    for (let i = -1; i <= 1; i++) {
      visible.push(images[(current + i + images.length) % images.length]);
    }
    return visible;
  };

  const next = () => setCurrent((c) => (c + 1) % images.length);
  const prev = () => setCurrent((c) => (c - 1 + images.length) % images.length);

  const visibleImages = getVisibleImages();

  return (
    <div className="w-full flex flex-col items-center mb-6">
      <div className="relative flex items-center justify-center gap-2 w-full" style={{ minHeight: '120px' }}>
        {images.length > 1 && (
          <button onClick={prev} className="absolute left-0 z-10 bg-white/70 rounded-full p-1 shadow hover:bg-white top-1/2 -translate-y-1/2">&#8592;</button>
        )}
        <div className="flex justify-center items-center w-full gap-2">
          {visibleImages.map((img, idx) => (
            <img
              key={idx}
              src={img}
              alt="Recommended Dish"
              className={`object-cover rounded-lg shadow ${idx === 1 ? 'border-2 border-primary scale-105' : 'opacity-80'}`}
              style={{ width: '110px', height: '80px', maxWidth: '33%', maxHeight: '90px', transition: 'all 0.2s' }}
            />
          ))}
        </div>
        {images.length > 1 && (
          <button onClick={next} className="absolute right-0 z-10 bg-white/70 rounded-full p-1 shadow hover:bg-white top-1/2 -translate-y-1/2">&#8594;</button>
        )}
      </div>
      <div className="flex gap-1 mt-2">
        {images.map((_, i) => (
          <span key={i} className={`inline-block w-2 h-2 rounded-full ${i === current ? 'bg-primary' : 'bg-muted'}`}></span>
        ))}
      </div>
    </div>
  );
};

export default Slideshow;
